import React, { useState  , useEffect} from 'react';
import axios from 'axios';
// import './Search.css';
import AccessoriesForm from './AccessoriesForm';
import TwoWheelerForm from '../TwoWheeler/TwoWheelerForm';
import { useInput } from '../Context';
import EmployeeDetails from '../EmployeeDetails/EmployeeDetails';
const Search = () => {
  const { inputValue, handleSearch, accessiories } = useInput();
  const [searchTerm, setSearchTerm] = useState('');
  // const [searchResults, setSearchResults] = useState([]);
  const [isSearchBarActive, setIsSearchBarActive] = useState(true);
  const [editingData, setEditingData] = useState(null); // Track the row being edited
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formMode, setFormMode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);


  useEffect(() => {
    // Retrieve the stored value from sessionStorage
    const storedPreference = sessionStorage.getItem('user');
    setUser(storedPreference);
  }, []);


  const handleToggleForm = () => {
    setIsFormOpen((prev) => !prev); // Toggle the form state
  };

  // Handle search when the user types
  // const handleSearch = async (term) => {
  //   if (term) {
  //     try {
  //       const response = await axios.get(`https://api.assetview.warrantyindia.com/search?q=${term}`);
  //       setSearchResults(response.data);  // Update search results with the response data
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //       setSearchResults([]);  // Clear search results on error
  //     }
  //   } else {
  //     setSearchResults([]);
  //   }
  // };

  // Handle input change and automatically search
  const handleInputChange = (e) => {
    const term = e.target.value;
    handleSearch(term);  // Trigger search for both employees and two-wheelers
  };

  const handleViewClick = (data) => {
    setEditingData(data);  // Populate the form with the clicked row's data
    setFormMode('view');   // Set mode to 'view'
  };

  // Handle the "Edit" button click
  const handleEditClick = (data) => {
    setEditingData(data);  // Populate the form with the clicked row's data
    setFormMode('edit');   // Set mode to 'edit'
  };

  // Handle form input change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setEditingData({ ...editingData, [name]: value });
  };

  

  // Handle form submit to save the edited data
  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    // Simple validation for required fields
    if (!editingData.employee_name || !editingData.contact_no) {
      alert("Please fill in all required fields.");
      return;
    }
  
    try {
      setLoading(true); // Set loading state
  
      const response = await axios.put(`https://api.assetview.warrantyindia.com/api/updateaccessories/${editingData.id}`, editingData);
  
      if (response.status === 200) {
        alert('Details updated successfully');
        setEditingData(null);
        // handleSearch();
      }
    } catch (error) {
      console.error('Error updating data:', error);
      alert("Failed to update. Please try again.");
    } finally {
      setLoading(false); // Reset loading state
    }
  };


  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); // Offset timezone difference
    return d.toISOString().slice(0, 10); // Get 'YYYY-MM-DD' format
  };


  const formatDateToDDMMYYYY = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); // Adjust for timezone difference
  
    const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with 0 if necessary
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with 0 if necessary
    const year = d.getFullYear(); // Get full year
  
    return `${day}/${month}/${year}`;
  };
  

  return (
    
    <>
      {/* <EmployeeDetails /> */}
      <input
        type="text"
        placeholder="Search by Employee Name or Email"
        className="search-bar"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setIsSearchBarActive(true)}
        onBlur={() => inputValue === '' && setIsSearchBarActive(true)}  // Reset the position if the search term is empty
        style={{display:'none'}}
      />


      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', cursor: 'pointer' }}>
        <h2 style={{ color: 'red' }}>Other Accessiories</h2> 
        {/* Conditionally render + or - icon based on isFormOpen */}
        {isFormOpen ? (
          <i
            // className="fa-solid fa-minus"
            // style={{ fontSize: '26px', cursor: 'pointer', color: 'red' }}
            // onClick={handleToggleForm}
          ></i>
        ) : (
          <i
            // className="fa-solid fa-plus"
            // style={{ fontSize: '26px', cursor: 'pointer', color: 'red' }}
            // onClick={handleToggleForm}
          ></i>
        )}
      </div>

 
      <div>
      {isFormOpen && <AccessoriesForm />}
      </div>

     
      <div className="search-results">
  {accessiories.length > 0 ? (
    <table border={5} className="result-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ backgroundColor: '#f1f1f1', textAlign: 'left' }}>
          <th style={{ padding: '10px', width: '150px' , fontWeight:'bold' }}>DEVICE NAME</th>
          <th style={{ padding: '10px', width: '150px' }}>Date of Issue</th>
          
          <th style={{ padding: '10px', width: '150px' }}>Serial No.</th>
          <th style={{ padding: '10px', width: '150px' }}>Device Transferred</th>
          <th style={{ padding: '10px', width: '150px' }}>Device Intake</th>
          <th style={{ padding: '10px', width: '150px' }}>Reporting Manager</th>
          <th style={{ padding: '10px', width: '150px' }}>Device Intake Date</th>
          <th style={{ padding: '10px', width: '150px' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {accessiories.map((result, index) => (
          <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
            <td style={{ padding: '10px', width: '150px', fontWeight:'bold'}}>{result.deviceName || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>
              {result.date_of_issue ? formatDateToDDMMYYYY(result.date_of_issue) : ''}
            </td>
           
            <td style={{ padding: '10px', width: '150px' }}>{result.serial_no || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>{result.device_transferred || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>{result.device_intake || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>{result.reporting_manager || ''}</td>
            <td style={{ padding: '10px', width: '150px' }}>
              {result.device_transferred_date ? formatDateToDDMMYYYY(result.device_transferred_date) : ''}
            </td>
            <td style={{ padding: '10px', display: 'flex', gap: '10px', flexDirection: 'column', justifyContent: 'center' }}>
              <button onClick={() => handleViewClick(result)} style={{ fontSize: '15px',}}>View</button>
              <button onClick={() => handleEditClick(result)} style={{ fontSize: '15px', }}>Edit</button>
              <button style={{ width: '100%' }} onClick={handleToggleForm}>Add New</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <button style={{ padding: '10px', background: 'green', color: 'white', border: 'none', cursor: 'pointer' }} onClick={handleToggleForm}>
       Create Other's Accessiories Data
      </button>
    </div>
  )}
</div>





      {/* Editing form */}
      {editingData && (
        <div className="edit-form-popup">
  <div className="edit-form">
    <h3>Edit Employee Details</h3>
    <form onSubmit={handleFormSubmit} className="edit-form-container">

    <div className="form-field">
        <label>Device Name:</label>
        <input
          type="text"
          name="deviceName"
          value={editingData.deviceName}
          onChange={handleFormChange}
        />
      </div>


      <div className="form-field">
        <label>Employee Name:</label>
        <input
          type="text"
          name="employee_name"
          value={editingData.employee_name}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field">
        <label>Regional Office:</label>
        <input
          type="text"
          name="regional_office"
          value={editingData.regional_office}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field">
        <label>Contact No.:</label>
        <input
          type="text"
          name="contact_no"
          value={editingData.contact_no}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field">
        <label>Email:</label>
        <input
          type="text"
          name="personal_email_id"
          value={editingData.personal_email_id}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field">
        <label>Address:</label>
        <input
          type="text"
          name="address"
          value={editingData.address}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field">
        <label>Date of Issue:</label>
        <input
          type="date"
          name="date_of_issue"
          value={editingData.date_of_issue ? formatDateToYYYYMMDD(editingData.date_of_issue) : ""}
          onChange={handleFormChange}
        />

      </div>
      <div className="form-field">
        <label>Model Name:</label>
        <input
          type="text"
          name="model_name"
          value={editingData.model_name}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field">
        <label>Serial No.:</label>
        <input
          type="text"
          name="serial_no"
          value={editingData.serial_no}
          onChange={handleFormChange}
        />
      </div>

      
      <div className="form-field">
        <label>Device Transferred:</label>
        <select
          name="device_transferred"
          value={editingData.device_transferred || 'no'}
          onChange={handleFormChange}
        >
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
      </div>

      

      {/* Conditional Field: Show if Device Transferred is "Yes" */}
      {editingData.device_transferred === 'yes' && (
        <>
          <div className="form-field">
            <label>Employee Name (Transferred):</label>
            <input
              type="text"
              name="device_transferred_employee_name"
              value={editingData.device_transferred_employee_name}
              onChange={handleFormChange}
            />
          </div>
          <div className="form-field">
            <label>Device Intake:</label>
            <select
              name="device_intake"
              className="custom-dropdown"
              value={editingData.device_intake || 'no'}
              onChange={handleFormChange}
            >
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>

          {editingData.device_intake === 'yes' && (
            <>
              <div className="form-field">
                <label>Reporting Manager:</label>
                <input
                  type="text"
                  name="reporting_manager"
                  value={editingData.reporting_manager}
                  onChange={handleFormChange}
                />
      </div>
              <div className="form-field">
                <label>Device Intake Date:</label>
                <input
                  type="date"
                  name="device_transferred_date"
                  value={editingData.device_transferred_date 
                          ? formatDateToYYYYMMDD(editingData.device_transferred_date)
                          : ''}
                  onChange={handleFormChange}
                />
              </div>
              <div className="form-field">
                <label>Exit Formality Complete:</label>
                <select
                  name="exit_formality_complete"
                  className="custom-dropdown"
                  value={editingData.exit_formality_complete || 'no'}
                  onChange={handleFormChange}
                >
                  <option value="no">No</option>
                  <option value="yes">Yes</option>
                </select>
              </div>
            </>
          )}
        </>
      )}

      {formMode === 'edit' ? <button type="submit">Save Changes</button> : null}

      <button type="button" onClick={() => setEditingData(null)}>Cancel</button>
    </form>
  </div>
  </div>
)}





    </>

  );
};

export default Search;
